import { render } from "./transfer_templates_list.vue?vue&type=template&id=0e9d5b29&scoped=true"
import script from "./transfer_templates_list.vue?vue&type=script&lang=js"
export * from "./transfer_templates_list.vue?vue&type=script&lang=js"

import "./transfer_templates_list.vue?vue&type=style&index=0&id=0e9d5b29&scoped=true&lang=css"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e9d5b29"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../../../../../Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QSelect,QTd});
